<template>
  <v-card
    :style="{
      backgroundColor: isMobile.isMobile ? 'transparent' : '#fff',
      marginLeft: isMobile.isMobile ? '0px' : '15px',
    }"
  >
    <div
      :style="{
        overflow: 'hidden',
        marginLeft: isMobile.isMobile ? '15px' : '0px',
        marginRight: isMobile.isMobile ? '15px' : '0px',
      }"
    >
      <md-toolbar
        class="header"
        :style="{
          height: isMobile.isMobile ? '44px' : '64px',
          minHeight: isMobile.isMobile ? '44px' : '64px',
          margin: isMobile.isMobile ? '10px 0px' : '0px',
          borderRadius: isMobile.isMobile ? '0px' : '0px',
        }"
      >
        <p
          class="titleWrap"
          :style="{
            height: isMobile.isMobile ? '25px' : '64px',
            lineHeight: isMobile.isMobile ? '25px' : '64px',
            marginLeft: isMobile.isMobile ? '0px' : '0px',
            textIndent: isMobile.isMobile ? '0px' : '20px',
          }"
        >
          媒体资源库
        </p>
        <v-btn
          large
          class="md-button md-success dropdown-toggle"
          @click="handleAdd"
          :style="{
            margin: isMobile.isMobile ? '0px' : '0px 0px 0px 10px',
            height: isMobile.isMobile ? '25px' : '',
          }"
        >
          <span class="iconfont icon-tianjia" style="font-size: 17px; margin-right: 2px"></span>
          添加资源文件
          <!-- 新建模型资源 -->
          <!-- <md-tooltip md-direction="top">添加资源文件</md-tooltip> -->
        </v-btn>

        <md-button
          v-if="isMobile.isMobile"
          class="md-toolbar-toggle md-just-icon md-round md-simple md-toolbar-section-end"
          :class="{ toggled: $sidebar.showSidebar }"
          :style="{float: 'right', color:'#fff !important',height:'25px'}"
          @click.stop="toggleSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>
        <div class="selectWrap md-toolbar-section-end" v-if="!isMobile.isMobile">
          <v-menu transition="slide-y-transition" offset-y nudge-bottom="12" :close-on-click="true">
            <template v-slot:activator="{ on, attrs, value }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                class="md-button md-success dropdown-toggle"
                id="deviceFilter"
              >
                {{ filterValue.name }}
                <v-icon :class="['ni', value ? 'rotate-180' : '']"
                  >ni ni-bold-down text-xs ms-1</v-icon
                >
              </v-btn>
            </template>

            <v-list class="py-1" dense max-height="300">
              <v-list-item-group active-class="v-List-actived" mandatory color="indigo">
                <v-list-item
                  class="list-item-hover-active py-0 text-center"
                  v-for="(item, index) in typeArr"
                  :key="index"
                  @click="filterChange(item)"
                >
                  <v-list-item-content class="pa-0">
                    <v-list-item-title
                      v-text="item.name"
                      class="text-body-2 ls-0 text-typo font-weight-600 mb-0"
                    >
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
          <v-btn large class="md-button md-success dropdown-toggle addModel" @click="setBtnSelect">
            <span v-if="resourceCartFlag == 0" class="iconfont btnSelect icon-qiapianxuanze-"
              ><md-tooltip md-direction="top" class="toopZindex">卡片模式</md-tooltip></span
            >

            <span v-if="resourceCartFlag == 1" class="iconfont btnSelect icon-liebiao">
              <md-tooltip md-direction="top" class="toopZindex">列表模式</md-tooltip></span
            >
          </v-btn>
        </div>
      </md-toolbar>
    </div>

    <div
      class="wraps"
      :style="{
        margin: isMobile.isMobile ? '0 15px' : '0px',
        backgroundColor: isMobile.isMobile ? '#fff' : '',
      }"
    >
      <div class="ResourceWrap">
        <div>
          <v-toolbar flat height="80">
            <v-text-field
              v-model="queryParams.name"
              class="filterValue"
              append-icon="mdi-magnify"
              label="请输入资源名称"
              single-line
              hide-details
              @keydown="keydownSearch"
            ></v-text-field>

            <md-tooltip md-direction="top">按回车以检索</md-tooltip>
          </v-toolbar>

          <div style="float: right; overflow: hidden"></div>
        </div>

        <md-content class="md-scrollbar md-layout ResourceListWrap" v-show="resourceCartFlag == 0">
          <div
            style="overflow: hidden; width: 100%; height: auto"
            class="md-layout"
            v-if="courseListLoading && !isMobile.isMobile"
          >
            <v-sheet
              v-for="(index, item) in 8"
              :key="index"
              :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
              class="md-layout-item md-xlarge-size-25 md-large-size-25 md-medium-size-25 md-small-size-25 md-xsmall-size-100 courseList"
            >
              <v-skeleton-loader class="mx-auto" max-width="100%" type="card"></v-skeleton-loader>
            </v-sheet>
          </div>
          <div
            :style="{
              display: 'flex',
              justifyContent: 'space-around',
              flexWrap: 'wrap',
              width: isMobile.isMobile ? '95%' : '0',
            }"
            v-if="courseListLoading && isMobile.isMobile"
          >
            <v-col
              v-for="n in 8"
              :key="n"
              cols="6"
              class="courseList md-layout-item md-xlarge-size-25 md-large-size-25 md-medium-size-25 md-small-size-25 md-xsmall-size-45"
              :style="{
                height: isMobile.isMobile ? '110px' : '239px',
                margin: isMobile.isMobile ? '10x 0px' : '5px 0',
                padding: isMobile.isMobile ? '0px' : '',
              }"
            >
              <v-skeleton-loader
                type="card"
                :style="{ height: isMobile.isMobile ? '110px' : '239px' }"
                class="mb-4"
              />
               
            </v-col>
          </div>
          <div
            v-else
            v-for="item in tableData"
            cols="auto"
            :key="item._id"
            :class="
              isMobile.isMobile
                ? 'ResourceList'
                : 'md-layout-item md-xlarge-size-25 md-large-size-25 md-medium-size-25 md-small-size-25 md-xsmall-size-100 ResourceList'
            "
            @click.stop="filePreview(item)"
            :max-height="isMobile.isMobile ? '105' : '240'"
            :height="isMobile.isMobile ? '105' : '240'"
          >
            <v-card
              elevation="6"
              :max-height="isMobile.isMobile ? '105' : '240'"
              :height="isMobile.isMobile ? '105' : '240'"
            >
              <span :class="typeIcon(item)" @click.stop>
                <md-tooltip md-direction="top">{{ item.typeName }}</md-tooltip>
              </span>

              <v-img
                :lazy-src="scoureImg(item)"
                class="coureListImg"
                :height="isMobile.isMobile ? '80px' : '190px'"
                :max-height="isMobile.isMobile ? '80px' : '190px'"
                :src="scoureImg(item)"
              >
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
              <div class="coureNameWrap">
                <p>{{ coureItem(item) }}</p>
              </div>

              <div class="editWrap">
                <div class="selectWrapAdd">
                  <v-btn @click.stop icon>
                    <v-icon style="color: #fff">mdi-dots-vertical</v-icon>
                  </v-btn>
                  <div class="selectContent">
                    <p
                      v-for="(items, index) in editList"
                      :key="index"
                      @click.stop="goToSettiing(item, items)"
                    >
                      <span
                        v-if="items.type == 'edit'"
                        v-hasPermi="['dev::resource::edit']"
                        class="iconfont icon-bianji1"
                        style="color: #fff; font-size: 13px; margin-right: 5px"
                      ></span>

                      <span
                        v-if="items.type == 'delete'"
                        v-hasPermi="['dev::resource::remove']"
                        class="iconfont icon-shanchutianchong"
                        style="display: inline-block; font-size: 13px; margin-right: 5px"
                      ></span>

                      <span
                        v-if="items.type == 'share'"
                        class="iconfont icon-fenxiang1"
                        style="display: inline-block; font-size: 13px; margin-right: 5px"
                      ></span>
                      <span>{{ items.title }}</span>
                    </p>
                  </div>
                </div>

                <!-- <p>
                  <span @click.stop="editItem(item)" v-hasPermi="['dev::resource::edit']">
                    <svg aria-hidden="true">
                      <use xlink:href="#icon-bianji1"></use>
                    </svg>
                    <md-tooltip md-direction="top">编辑资源</md-tooltip>
                  </span>

                  <span @click.stop="deleteItem(item)" v-hasPermi="['dev::resource::remove']">
                    <svg aria-hidden="true">
                      <use xlink:href="#icon-shanchutianchong"></use>
                    </svg>
                    <md-tooltip md-direction="top">删除资源</md-tooltip>
                  </span>

                   <span @click.stop="previewQR(item)">
                      <span class="iconfont icon-fenxiang1" style="font-size: 28px; color:#fff"  ></span>
                    <md-tooltip md-direction="top">分享</md-tooltip>
                  </span>
                </p> -->
              </div>
            </v-card>
          </div>
        </md-content>

        <v-data-table
          v-show="resourceCartFlag == 1"
          :headers="headers"
          :items="tableData"
          no-data-text="暂无数据"
          :items-per-page="50"
          hide-default-footer
          width="100%"
          class="table-striped table-hover mx-5"
          id="tableWrap"
        >
          <template v-slot:item.num="{ item }">{{ item.num }}</template>
          <template #[`item.name`]="{ item }">
            <a
              style="color: #9c27b0; cursor: pointer"
              @click="filePreview(item)"
              class="viewMedium"
              >{{ item.name }}</a
            >
          </template>
          <template #[`item.size`]="{ item }">
            {{ (item.size / (1024 * 1024)).toFixed(1) + 'MB' }}
          </template>
          <!-- <template #[`item.qrImage`]="{ item }">
            <img
              v-show="item.qrImage"
              :src="getBase64URL(item.qrImage)"
              width="50"
              height="50"
              style="cursor: pointer"
              @click="previewQR(item)"
              class="viewMediumImg"
            />
          </template> -->
          <template #[`item.option`]="{ item }">
            <v-btn
              v-hasPermi="['dev::resource::edit']"
              icon
              color="success"
              class="editMedium"
              small
              @click.native="editItem(item)"
            >
              <span class="material-icons" style="font-size: 20px">edit</span>
              <md-tooltip md-direction="top">编辑资源</md-tooltip>
            </v-btn>
            <v-btn
              v-hasPermi="['dev::resource::remove']"
              icon
              color="error"
              class="delMedium"
              small
              @click.native="deleteItem(item)"
            >
              <span class="material-icons" style="font-size: 20px">delete_forever</span>
              <md-tooltip md-direction="top">删除资源</md-tooltip>
            </v-btn>
            <v-btn icon small color="success" @click="previewQR(item)" class="editMedium">
              <span
                class="iconfont icon-fenxiang1"
                style="font-size: 17px; font-weight: 700"
              ></span>
              <md-tooltip md-direction="top">分享</md-tooltip>
            </v-btn>
          </template>
        </v-data-table>

        <div style="margin-top: 20px; margin-bottom: 20px; overflow: hidden">
          <div style="">
            <v-pagination
              prev-icon="fa fa-angle-left"
              next-icon="fa fa-angle-right"
              class="pagination"
              color="#4caf50"
              :value="pagination.currentPage"
              :length="pageCount"
              @input="inputChange"
              circle
              :total-visible="7"
            ></v-pagination>
          </div>
        </div>

        <v-progress-circular
          indeterminate
          v-if="isLoading"
          color="rgb(76, 175, 80)"
          class="loadingEl"
        ></v-progress-circular>
      </div>
    </div>
    <v-dialog v-model="showQRDialog" max-width="300px">
      <v-img class="bg-white" width="300" :aspect-ratio="1" :src="currQRImage" cover></v-img>
    </v-dialog>
    <ResourceLibraryFrom
      ref="ResourceLibraryFrom"
      :dialog-edit.sync="dialogFrom"
      :title="dialotitle"
      :form-data="editedItem"
      @submit="handleSubmit"
      @closeDialog="closeDialog"
    />
  </v-card>
</template>
<script>
import { Pagination } from '@/components';
import Swal from 'sweetalert2';
import { mapGetters } from 'vuex';
import {
  listResourceLibrary,
  addResourceLibrary,
  updateResourceLibrary,
  delResourceLibrary,
} from '@/api/resource_library';
import ResourceLibraryFrom from './Action/ResourceLibraryFrom';
import { _Base64encode } from '@/util/base64';
import { pad } from '@antv/x6/lib/util/string/string';
import { Background } from '@antv/x6/lib/registry';

export default {
  inject: {
    theme: {
      default: { isDark: false },
    },
  },
  components: {
    Pagination,
    ResourceLibraryFrom,
  },
  computed: {
    ...mapGetters(['resourceCardType', 'isMobile']),
    pageCount() {
      return this.pagination.total ? Math.ceil(this.pagination.total / this.pagination.perPage) : 0;
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.pagination.total;
    },

    resourceCardType() {
      return this.$store.state.task.resourceCardType;
    },
  },
  data() {
    return {
      courseListLoading: false,
      editList: [
        {
          title: '编辑资源',
          type: 'edit',
        },
        {
          title: '删除资源',
          type: 'delete',
        },
        {
          type: 'share',
          title: '分享资源',
        },
      ],
      filterValue: {
        name: '全部',
        type: 'all',
      },
      typeArr: [
        { name: '全部', type: 'all' },
        { name: '图片', type: '0' },
        { name: '视频', type: '1' },
        { name: '音频', type: '2' },
        { name: '文档', type: '3' },
        { name: '其他', type: '4' },
        { name: 'pdf', type: '5' },
      ],
      // scoureImg: require('@/assets/img/ziyuan.png'),
      isLoading: false,
      headers: [
        {
          text: '序 号',
          align: 'start',
          value: 'num',
          width: 120,
        },

        {
          text: '资源名称',
          align: 'start',
          value: 'name',
          sortable: false,
        },
        {
          text: '资源类型',
          align: 'start',
          value: 'typeName',

          sortable: false,
        },
        {
          text: '资源大小',
          align: 'start',
          value: 'size',

          sortable: false,
        },
        // {
        //   text: '二维码',
        //   align: 'start',
        //   value: 'qrImage',
        //   sortable: false,
        // },
        {
          text: '操作',
          align: 'center',
          value: 'option',
          width: 120,
          sortable: false,
        },
      ],
      currentSort: 'name',
      currentSortOrder: 'asc',
      pagination: {
        perPage: 8,
        currentPage: 1,
        perPageOptions: [8, 12, 16, 20],
        total: 0,
      },
      queryParams: {},
      searchQuery: '',
      propsToSearch: ['name'],
      tableData: [],
      searchedData: [],
      dialogFrom: false,
      editedItem: {},
      dialotitle: '',
      showQRDialog: false,
      currQRImage: '',
      resourceCartFlag: 0,
    };
  },
  mounted() {
    this.courseListLoading = true;
    this.resourceCartFlag = this.resourceCardType;

    if (this.isMobile.isMobile) {
      this.resourceCartFlag = 0;
    }
    this.getList();
    let that = this;
    this.$EventBus.$on('addUploadMedium', function (data) {
      if (data) {
        that.dialogFrom = true;
        that.dialotitle = '新增';
      } else {
        that.dialogFrom = false;
      }
    });
  },
  watch: {
    resourceCartFlag(news) {
      if (this.isMobile.isMobile) {
        this.$store.state.task.resourceCardType = 0;
      } else {
        this.$store.state.task.resourceCardType = news;
      }
    },

    'queryParams.name'() {
      // this.pagination.currentPage = 1;
      // this.getList();
    },
    'pagination.currentPage'() {
      this.getList();
    },
    'pagination.perPage'() {
      this.pagination.currentPage = 1;
      this.getList();
    },
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    scoureImg(data) {
      // this.filterValue.type

      if (data.fullPath.lastIndexOf('mp3') !== -1 || data.accept.indexOf('audio') !== -1) {
        return require('@/assets/img/yp.png');
      } else if (data.fullPath.lastIndexOf('mp4') !== -1 || data.accept.indexOf('video') !== -1) {
        return require('@/assets/img/sp.png');
      } else if (
        data.fullPath.lastIndexOf('jpg') !== -1 ||
        data.fullPath.lastIndexOf('png') !== -1 ||
        data.fullPath.lastIndexOf('jpeg') !== -1 ||
        data.fullPath.lastIndexOf('bpm') !== -1 ||
        data.fullPath.lastIndexOf('gif') !== -1 ||
        data.accept.lastIndexOf('image') !== -1
      ) {
        return require('@/assets/img/tp.png');
      } else if (this.filterValue.type == '5' || data.fullPath.lastIndexOf('pdf') !== -1) {
        return require('@/assets/img/PDF.png');
      } else if (this.filterValue.type == '4') {
        return require('@/assets/img/qt.png');
      } else if (this.filterValue.type == '3') {
        return require('@/assets/img/wd.png');
      }

      //       { name: '全部', type: 'all' },
      // { name: '图片', type: '0' },
      // { name: '视频', type: '1' },
      // { name: '音频', type: '2' },
      // { name: '文档', type: '3' },
      // { name: '其他', type: '4' },
      // { name: 'pdf', type: '5' },
    },
    goToSettiing(item, items) {
      switch (items.type) {
        case 'edit':
          this.editItem(item);
          break;
        case 'delete':
          this.deleteItem(item);
          break;

        case 'share':
          this.previewQR(item);
          break;

        // case 'editDetail':
        //   this.goToCoureDetail(item);
        //   break;
      }
    },
    filterChange(val) {
      this.filterValue = val;
      this.pagination.currentPage = 1;
      this.getList();
    },
    setBtnSelect() {
      this.resourceCartFlag = !this.resourceCartFlag;
    },
    keydownSearch(e) {
      // 点击Enter
      if (e.keyCode === 13) {
        this.pagination.currentPage = 1;
        this.getList();
      }
    },
    inputChange(e) {
      this.pagination.currentPage = e;
      this.getList();
    },
    typeIcon(data) {
      let returnClass = '';
      if (data.fullPath.lastIndexOf('mp3') !== -1 || data.accept.indexOf('audio') !== -1) {
        returnClass = 'iconfont icon-yinpin iconType';
      } else if (data.fullPath.lastIndexOf('mp4') !== -1 || data.accept.indexOf('video') !== -1) {
        returnClass = 'iconfont icon-shipin iconType';
      } else if (
        data.fullPath.lastIndexOf('jpg') !== -1 ||
        data.fullPath.lastIndexOf('png') !== -1 ||
        data.fullPath.lastIndexOf('jpeg') !== -1 ||
        data.fullPath.lastIndexOf('bpm') !== -1 ||
        data.fullPath.lastIndexOf('gif') !== -1 ||
        data.accept.lastIndexOf('image') !== -1
      ) {
        returnClass = 'iconfont icon-tupian iconType';
      } else if (data.fullPath.lastIndexOf('pdf') !== -1) {
        returnClass = 'iconfont icon-wendang iconType';
      }
      return returnClass;
    },

    coureItem(item) {
      return item.name;
    },
    base64ImgtoFile(dataurl, filename = 'file') {
      //将base64格式分割：['data:image/png;base64','XXXX']

      const arr = dataurl.split(',');
      // .*？ 表示匹配任意字符到下一个符合条件的字符 刚好匹配到：
      // image/png
      const mime = arr[0].match(/:(.*?);/)[1]; //image/png
      //[image,png] 获取图片类型后缀
      const suffix = mime.split('/')[1]; //png
      const bstr = atob(arr[1]); //atob() 方法用于解码使用 base-64 编码的字符串
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], `${filename}.${suffix}`, {
        type: mime,
      });
    },

    getBase64URL(pic) {
      if (!pic) {
        console.log(pic);
        return '';
      } else {
        const blob = this.base64ImgtoFile(pic);
        const blobUrl = window.URL.createObjectURL(blob);
        return blobUrl;
      }
    },
    getList() {
      let query = Object.assign(this.queryParams, this.pagination);
      query.type = this.filterValue.type;
      this.isLoading = true;
      listResourceLibrary(query)
        .then(res => {
          this.courseListLoading = false;
          this.isLoading = false;
          this.tableData = res.data.rows;
          this.tableData.forEach((item, index) => {
            //  console.log(item)
            item.num = index + 1;
          });
          this.pagination.total = res.data.total;
        })
        .catch(err => {
          this.courseListLoading = false;
        });
    },
    /**
     * 文件预览
     */
    filePreview(e) {
      window.open(
        'http://file-preview.icubespace.com/onlinePreview?url=' +
          encodeURIComponent(_Base64encode(e.fullPath)),
        '_blank'
      );
    },
    previewQR(e) {
      this.showQRDialog = true;
      this.currQRImage = this.getBase64URL(e.qrImage);
    },
    /**
     * 新增/修改提交操作
     */
    handleSubmit(form) {
      console.log('form :>> ', form);
      const USER_INFO = localStorage.USER_INFO;
      if (form._id) {
        form.updater = USER_INFO.name || USER_INFO.username || '';
        updateResourceLibrary(form).then(res => {
          this.$refs.ResourceLibraryFrom.loading = false;
          console.log(res);
          if (res.code === '200') {
            this.$swal.fire('修改成功', '', 'success');
            this.closeDialog();
            this.getList();
          }
        });
      } else {
        form.creater = USER_INFO.name || USER_INFO.username || '';
        form.updater = USER_INFO.name || USER_INFO.username || '';
        addResourceLibrary(form).then(res => {
          console.log(res);
          if (res.code === '200') {
            this.$swal.fire('新增成功', '', 'success');
            this.closeDialog();
            this.getList();
          }
        });
      }
    },
    /**
     * 关闭弹窗
     */
    closeDialog() {
      this.dialogFrom = false;
      this.editedItem = {};
    },
    /**
     * 新增操作
     */
    handleAdd() {
      this.dialogFrom = true;
      this.$refs.ResourceLibraryFrom.reset();
      this.dialotitle = '新增';
    },
    /**
     * 修改操作
     */
    editItem(item) {
      this.$refs.ResourceLibraryFrom.reset();
      this.dialotitle = '修改';
      this.editedItem = JSON.parse(JSON.stringify(item));
      this.dialogFrom = true;
    },
    /**
     * 删除操作
     */
    async deleteItem(item) {
      let result = await Swal.fire({
        title: '删除信息',
        text: `资源"${item.name}"被删除后将无法恢复，请确认！`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'md-button md-success btn-fill',
        cancelButtonClass: 'md-button md-danger btn-fill',
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        buttonsStyling: false,
      });

      if (result.value) {
        delResourceLibrary({ _id: item._id }).then(res => {
          if (res.code === '200') {
            this.$swal.fire('删除成功', '', 'success');
            this.getList();
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pagination {
  margin-right: 30px;
  float: right;
  padding: 0;
  overflow: hidden;
}
.ResourceWrap {
  /* min-height: 650px; */
  overflow-x: hidden;
  /* max-height: 660px; */
  /* background-image: url('@/assets/socore_Img.png');
  background-image: url('../../assets/img/socore_Img'); */
}
.wraps {
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
}

.ResourceList {
  margin: 10px 0;
  height: 240px;
  max-height: 240px;
  cursor: pointer;
  z-index: 1;
}

.coureNameWrap {
  width: 100%;
  height: 40px;
  /* background: red; */
  margin-top: 5px;
  text-align: center;
}
.coureNameWrap p {
  height: 40px;
  line-height: 40px;
  color: #000;
  font-size: 14px;
  margin-top: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 5px;
}

.ResourceList:hover .coureListImg {
  opacity: 0.8;
}

.toggleBtn {
  margin-top: 15px;
  margin-left: 20px;
}

.toggleBtn svg {
  width: 1.5em !important;
  height: 1.5em !important;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
  color: #43a047;
}
::v-deep .paginated-table table tbody tr td {
  border-bottom: unset !important;
  max-width: unset;
}
::v-deep .paginated-table table thead tr th {
  border-bottom: unset !important;
}

//推按出现裂痕隐藏图片
// img[src=""],img:not([src]){

//  opacity:0;

// }

.loadingEl {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  z-index: 999;
}

.v-card {
  position: relative;
  overflow: hidden;
}

.ResourceList > .v-card:hover .editWrap {
  margin: auto;
  width: 100%;
  height: 190px;
  top: 0px;
  background: #000000a3;
}

.editWrap {
  position: absolute;
  width: 100%;
  height: 190px;
  line-height: 40px;
  transition: 0.5s;
  top: 0px;
  text-align: right;
}

.yiinPin {
  font-size: 20px;
  color: red;
}

.editWrap p {
  // padding: 0 10px;
  display: none;
}

.ResourceList > .v-card:hover .editWrap p {
  display: block;
}

// .editWrap p span:nth-child(1) svg{
//    font-size: 20px;
// }
.editWrap p span {
  margin: 0 5px;
}
.editWrap p svg {
  width: 1.5em !important;
  height: 1.5em !important;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
  margin-top: 20px;
  color: #fff;
}

.iconType {
  position: absolute;
  left: 5px;
  top: 0;
  font-size: 25px;
  color: #fff;
  z-index: 999;
}

.header {
  background: #4caf50 !important;
  height: 64px;
  overflow: hidden;
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  // margin-bottom: 0px;
  margin: 0 0 0 0;
}

.titleWrap {
  float: left;
  line-height: 64px;
  height: 64px;
  margin-left: 20px;
  color: #fff;
  text-indent: 20px;
  margin-bottom: 0px;
}

.selectWrap {
  float: right;
  margin-right: 10px;
  height: auto;
  overflow: hidden;
  height: 62px;
  line-height: 62px;
  cursor: pointer;
}
.btnSelect {
  padding: 5px 6px;
  font-size: 20px;
  color: #fff;
}

.selectWrap #deviceFilter {
  padding: 0 0 0 16px !important;
}

.selectWrapAdd {
  display: inline-block;
  position: relative;
}
.selectWrapAdd:hover .selectContent {
  display: block;
}
.selectContent {
  z-index: 999999;
  position: absolute;
  top: 35px;
  right: 20px;
  width: 110px;
  height: auto;
  padding: 10px 5px;
  background: #000000a3;
  display: none;
  overflow: hidden;
  border-radius: 5px;
}
.selectContent p {
  text-align: left;
  margin: 0px;
  margin-bottom: 5px;
}
.selectContent p:hover {
  background: #343434;
}
.selectContent p span {
  color: #fff;
  font-size: 13px;
}
.toopZindex {
  z-index: 99999;
}

@media (max-width: 600px) {
  .pagination{
    margin-right: 0px;
  }
  .ResourceListWrap {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
  }

  .filterValue{
    padding: 0 0px;
  }
  .ResourceList {
    width: 45% !important;
    height: 110px;
    margin: 8px;
    padding-right: 5px !important;
    padding-left: 5px !important;
  }

  .ResourceListWrap .ResourceList:nth-child(1) {
    margin-top: 0px !important;
  }
  .ResourceListWrap .ResourceList:nth-child(2) {
    margin-top: 0px !important;
  }

  .coureNameWrap {
    height: 25px;
    margin-top: 0px;
    line-height: 25px;
  }
  .coureNameWrap p {
    height: 25px;
    line-height: 25px;
    font-size: 12px;
    margin-bottom: 0px;
    margin-top: 0px;
  }
  .selectContent {
    width: 90px;
    top: 25px;
    padding: 5px;
  }

  .selectContent p span {
    font-size: 10px !important;
  }
  .selectContent p {
    margin-bottom: 0px;
    line-height: 20px;
  }

  .editWrap {
    height: 85px;
  }
  .courseList {
    margin: 10px 0;
  }
  .header{
    border-radius: 0px !important;
    box-shadow: none !important;
    display: block;
  }
}
</style>


